import { getAccountBadgeValidDistributionStatusChanges, } from '../../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Button, Typography } from '@mui/material';
import React from 'react';
import { stopEventPropagation } from '../../utils/stopEventPropagationHandler';
export const AccountBadgeDistributionLabel = ({ status, distributionStatus, distributionStatusLastUpdatedAt, onDistributionStatusEdit, }) => {
    const { t } = useBadgingTranslation();
    const recommendedDistributionStatuses = getAccountBadgeValidDistributionStatusChanges({
        status,
        distributionStatus,
    }).recommended;
    const getRecommendedStatusActionLabel = (distributionStatus) => {
        switch (distributionStatus) {
            case 'printed':
                return t('badges.badgeDetails.accountBadgeTable.actions.markAsPrinted');
            case 'distributed':
                return t('badges.badgeDetails.accountBadgeTable.actions.markAsDistributed');
            default:
                return null;
        }
    };
    const renderActionButtons = () => recommendedDistributionStatuses.map((distributionStatus) => (React.createElement(Button, { size: 'small', onClick: stopEventPropagation(() => onDistributionStatusEdit(distributionStatus)), key: distributionStatus }, getRecommendedStatusActionLabel(distributionStatus))));
    switch (distributionStatus) {
        case 'processing':
        case 'printed':
            return renderActionButtons();
        case 'distributed':
            return distributionStatusLastUpdatedAt ? (React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, t('badges.badgeDetails.accountBadgeTable.dateLabels.lastUpdate', {
                date: new Date(distributionStatusLastUpdatedAt).toLocaleDateString(),
            }))) : null;
        case 'not-printed':
        default:
            return (React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, "-"));
    }
};
